import React from "react";
import { Box, Typography } from "@material-ui/core";

import { useAppSelector } from "store";

import KPIComparison from "components/visuals/KPIComparison";
import numberFormatter from "utils/numberFormatter";
import { selectSelectedStoreByCostType } from "modules/customer/insights/cost/costSlice";
import useColourPalette from "components/visuals/useColourPalette";
import { selectStoreCostsAndOpportunity } from "modules/customer/insights/cost/storeCosts/storeCostsSlice";

const CostAsPercentageOfRevenue = () => {
    const colours = useColourPalette();
    const selectedStoreAndCost = useAppSelector(selectSelectedStoreByCostType);
    const storeCostsAndOpportunity = useAppSelector(selectStoreCostsAndOpportunity);
    const clusterMedianCostPercentage = storeCostsAndOpportunity?.clusterMedianCosts.percentageOfRevenue ?? 0;

    const difference = selectedStoreAndCost ? (selectedStoreAndCost.costAsPercentageOfRevenue - clusterMedianCostPercentage) : 0;
    const label = `${selectedStoreAndCost?.storeName} ${selectedStoreAndCost?.costName} costs as a % of revenue`;

    return (
        <Box width="100%" height="100%" data-cy="costs-as-percentage-of-revenue">
            <KPIComparison
                isLoading={false}
                hasErrors={false}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: colours.comparators[0] }}>
                        {numberFormatter.toPercentage(selectedStoreAndCost?.costAsPercentageOfRevenue, false)}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h5" component="div" style={{ color: colours.comparators[1] }}>
                        {numberFormatter.toPercentage(clusterMedianCostPercentage ?? 0, false)}
                    </Typography>
                }
                comparisonLabel={`${selectedStoreAndCost?.costName} cost cluster`}
                differenceValue={
                    <Typography variant="h6" component="div" style={{ color: "#FFFFFF" }}>
                        {numberFormatter.toPercentage(difference, false)}
                    </Typography>
                }
                differenceLabel="Difference"
            />
        </Box>
    );
};

export default CostAsPercentageOfRevenue;
